/* globals sh_related_jobs_config */

/* eslint vue/one-component-per-file:0 */

import { maybe_open_review_popup } from 'reviews';
import { open_popup } from 'rh-widget';
import { createApp } from 'vue';

import ExpiredJobsApp from './expired-jobs-app/app.vue';
import RelatedApp from './related-jobs-app/app.vue';

(function () {
	const button_els = document.querySelectorAll(`.single-job-expired .btn`);
	if (button_els.length === 0) {
		return;
	}

	function on_click() {
		document.body.classList.toggle(`open-expired-job-listing`);
	}

	for (const button_el of button_els) {
		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const container_el = document.getElementById(`js-single-job-apply`);
	if (!container_el) {
		return;
	}

	const button_el = container_el.querySelector(`.btn-solid`);
	if (!button_el) {
		return;
	}

	const dropdown_el = container_el.querySelector(`.dropdown`);
	if (!dropdown_el) {
		return;
	}

	function open() {
		container_el.classList.add(`open`);

		document.body.addEventListener(`click`, close_click);
		window.addEventListener(`keydown`, close_esc);
	}

	function close() {
		container_el.classList.remove(`open`);

		document.body.removeEventListener(`click`, close_click);
		window.removeEventListener(`keydown`, close_esc);
	}

	function close_esc(e) {
		if (e.key === `Escape`) {
			close();
		}
	}

	function close_click(e) {
		if (!dropdown_el.contains(e.target) && !button_el.contains(e.target)) {
			close();
		}
	}

	function on_click(e) {
		e.preventDefault();

		if (container_el.classList.contains(`open`)) {
			close();
		} else {
			open();
		}
	}

	button_el.addEventListener(`click`, on_click);
})();

(function () {
	const button_els = document.getElementsByClassName(`btn-trigger-review`);
	if (button_els.length === 0) {
		return;
	}

	function on_click(e) {
		const button_el = e.currentTarget;

		maybe_open_review_popup(e, button_el.href);
	}

	for (const button_el of button_els) {
		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const button_els = document.querySelectorAll(`[data-open_rh_widget]`);
	if (button_els.length === 0) {
		return;
	}

	const data_el = document.getElementById(`job-data`);
	if (!data_el) {
		return;
	}

	const data = JSON.parse(data_el.textContent);

	function on_click() {
		open_popup(data);
	}

	for (const button_el of button_els) {
		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const app_el = document.getElementById(`js-related-jobs`);
	if (!app_el) {
		return;
	}

	if (typeof sh_related_jobs_config === `undefined`) {
		return;
	}

	const events = [`mousemove`, `scroll`, `keydown`, `touchstart`];

	function init() {
		for (const event of events) {
			window.removeEventListener(event, init);
		}

		createApp(RelatedApp, {
			api_url: sh_related_jobs_config.api_url,
			uuid: sh_related_jobs_config.uuid,
			hub_url: sh_related_jobs_config.hub_url,
			logo_url_template: sh_related_jobs_config.logo_url_template,
		}).mount(app_el);
	}

	for (const event of events) {
		window.addEventListener(event, init, {
			passive: true,
		});
	}
})();

(function () {
	const button_els = document.querySelectorAll(`[data-company-read-more]`);
	if (button_els.length === 0) {
		return;
	}

	function on_click(e) {
		const button_el = e.currentTarget;
		const wrapper_el = button_el.closest(`[data-company-description]`);
		const more_el = wrapper_el ? wrapper_el.querySelector(`[data-company-description-more]`) : null;
		if (!wrapper_el || !more_el) {
			return;
		}

		const expanded = wrapper_el.classList.toggle(`expanded`);

		more_el.hidden = !expanded;
		button_el.querySelector(`span`).textContent = expanded ? `Read less` : `Read more`;
	}

	for (const button_el of button_els) {
		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const tabs_el = document.querySelector(`.job-tabs`);
	if (!tabs_el) {
		return;
	}

	const description_panel_el = document.getElementById(`job-panel-description`);
	const company_panel_el = document.getElementById(`job-panel-company`);
	if (!description_panel_el || !company_panel_el) {
		return;
	}

	const tab_els = tabs_el.querySelectorAll(`.job-tabs-btn`);

	document.documentElement.classList.add(`js-company-tabs`);

	function activate(tab_el) {
		const panel_id = tab_el.getAttribute(`aria-controls`);

		for (const other_tab_el of tab_els) {
			const active = other_tab_el === tab_el;

			other_tab_el.classList.toggle(`active`, active);
			other_tab_el.setAttribute(`aria-selected`, active ? `true` : `false`);
			other_tab_el.setAttribute(`tabindex`, active ? `0` : `-1`);
		}

		description_panel_el.hidden = panel_id !== `job-panel-description`;
		company_panel_el.hidden = panel_id !== `job-panel-company`;
	}

	function on_click(e) {
		const tab_el = e.currentTarget;

		activate(tab_el);

		tabs_el.scrollIntoView({
			behavior: `smooth`,
			block: `start`,
		});
	}

	for (const tab_el of tab_els) {
		tab_el.addEventListener(`click`, on_click);
	}

	activate(tab_els[0]);

	const desktop_media = window.matchMedia(`(min-width: 811px)`);

	desktop_media.addEventListener(`change`, (e) => {
		if (e.matches) {
			activate(tab_els[0]);
		}
	});
})();

(function () {
	const app_el = document.getElementById(`js-expired-jobs`);
	if (!app_el) {
		return;
	}

	if (typeof sh_related_jobs_config === `undefined`) {
		return;
	}

	const app = createApp(ExpiredJobsApp, {
		api_url: sh_related_jobs_config.api_url,
		uuid: sh_related_jobs_config.uuid,
		hub_url: sh_related_jobs_config.hub_url,
		logo_url_template: sh_related_jobs_config.logo_url_template,
	});

	app.mount(app_el);
})();
